module.exports = __webpack_public_path__ + "static/media/avatar-1.d4c67e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/happy-customers/avatar-1.png
// module id = 2243
// module chunks = 0